export function truncateText(text: string, maxLength: number) {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
}

export function truncateTextWithSearchTerm(
  text: string,
  searchTerm: string,
  maxLength: number,
): string {
  if (text.length <= maxLength) {
    return text;
  }

  if (!searchTerm) {
    return truncateText(text, maxLength);
  }

  const searchIndex = text.toLowerCase().indexOf(searchTerm.toLowerCase());

  // If search term not found, fall back to regular truncation
  if (searchIndex === -1) {
    return truncateText(text, maxLength);
  }

  const searchEndIndex = searchIndex + searchTerm.length;
  const availableLength = maxLength - 3; // Account for "..."

  // If search term fits at the beginning
  if (searchEndIndex <= availableLength) {
    return text.slice(0, availableLength) + "...";
  }

  // If search term fits at the end
  if (text.length - searchIndex <= availableLength) {
    return "..." + text.slice(text.length - availableLength);
  }

  // Center the search term
  const beforeLength = Math.floor((availableLength - searchTerm.length) / 2);
  const startIndex = Math.max(0, searchIndex - beforeLength);
  const endIndex = Math.min(text.length, startIndex + availableLength);

  const needsStartEllipsis = startIndex > 0;
  const needsEndEllipsis = endIndex < text.length;

  let result = text.slice(startIndex, endIndex);

  if (needsStartEllipsis) result = "..." + result;
  if (needsEndEllipsis) result = result + "...";

  return result;
}
